import { Token } from './../auth/dto/token.dto';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from "app/auth/service/authentication.service";
import { StorageService } from "app/service/storage.service";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private authenticationService: AuthenticationService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = JSON.parse(this.storageService.getItem('user'));
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: currentUser.token
        }
      });
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.headers.has('new-token')) {
            const token = {
              token: event.headers.get('new-token'),
              tokenExpiresIn: parseInt(event.headers.get('new-token-expires'), 10),
            } as Token;
            this.authenticationService.handleNewToken(token);
          }
        }
      })
    );
  }
}
